<ng-container *ngIf="!!errorType" [ngSwitch]="errorType">
  <div class="error-container" [style]="{ color: previewMode === 'popup' ? 'var(--gray-100)' : 'inherit' }">
    <ng-container *ngSwitchCase="'loadingError'">
      <u-icon [model]="{ type: 'font', value: 'icon-exclamation-mark-circle' }" [styles]="{ fontSize: '24px' }"></u-icon>
      <span class="preview-error-message">We’re having trouble loading your file right now</span>
      <div class="preview-error-buttons">
        <u-button
          [forceSecondaryDarkMode]="previewMode === 'popup'"
          label="Try again"
          type="secondary"
          [styles]="{ width: '124px' }"
          (onClick)="reload.emit()"
        ></u-button>
        <u-button
          label="open"
          type="primary"
          fontIcon="launch"
          [iconStyles]="{ fontSize: '12px' }"
          [styles]="{ width: '124px' }"
          (onClick)="open.emit()"
        ></u-button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'unsupportedFileType'">
      <u-icon [model]="icon" [styles]="{ width: '32px', height: '32px', marginBottom: '16px' }"></u-icon>
      <p class="preview-error-message">No preview available</p>
    </ng-container>

    <ng-container *ngSwitchCase="'unEnablePreview'">
      <div class="restricted-container">
        <u-icon [model]="{ type: 'font', value: 'icon-lock-fill' }" [styles]="{ fontSize: '24px' }"></u-icon>
        <div class="restricted-message">
          <span
            >Results will not display content for restricted links.
            <a href="https://help.unleash.so/docs/restricted-links" target="_blank" class="link-button">{{ ' Learn more' }}</a>
          </span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'PasswordException'">
      <span class="preview-error-icon icon-lock"></span>
      <p class="preview-error-message">This file is protected.<br />Preview is not available</p>
    </ng-container>

    <ng-container *ngSwitchCase="'fileTooBig'">
      <p class="preview-error-message">Couldn’t preview file<br />The file is too large to preview</p>
      <u-button
        label="Download"
        type="primary"
        [styles]="{ width: '148px', marginTop: '8px' }"
        (onClick)="download.emit()"
        [fontIcon]="'download2'"
      ></u-button>
    </ng-container>
  </div>
</ng-container>
